export default __webpack_public_path__ + "static/media/portfolioimage2.cc67f53f.png";